import { render } from "./service-account-admins.vue?vue&type=template&id=68e93895&lang=pug"
import script from "./service-account-admins.vue?vue&type=script&lang=js"
export * from "./service-account-admins.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__